import { render, staticRenderFns } from "./org-info-chart.vue?vue&type=template&id=b2f92eec&"
import script from "./org-info-chart.vue?vue&type=script&lang=js&"
export * from "./org-info-chart.vue?vue&type=script&lang=js&"
import style0 from "./org-info-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports